<div class="w-100">
  <div class="mb-3">
    <mwp-card-content-header [url]="apiUrl" />
  </div>
  @if (isLoading) {
    <mwp-placeholder-card />
  }

  @if (!isLoading && displayNoRequests && !isDynamicErrorMessage) {
    <div class="message-container blue-fill text-centered">
      <mwp-text-translate [text]="noRequestsMessage" jsonKey="noRequestsMessage" [isHTML]="true" />
    </div>
  }
  @if (!isLoading && displayNoRequests && isDynamicErrorMessage) {
    <div class="message-container blue-fill text-centered">
      <mwp-text-translate [text]="noRequestsMessage" [jsonKey]="jsonKey" />
    </div>
  }
  @if (!isLoading && !displayNoRequests && !isDynamicErrorMessage) {
    <div class="message-container blue-fill mb-4">
      <mwp-text-translate text="Please select a Benefit Request below to continue." jsonKey="pleaseSelectABenefitRequestBelowToContinue." />
    </div>
  }

  @if (benefitRequests) {
    <div>
      <!-- HSA -->
      @if (displayHSA) {
        <div class="content-container col-12 mb-4">
          <div class="d-flex justify-content-between align-items-center p-1">
            <div>
              <div class="benefit-request-category">
                HSA
              </div>
              @for (request of benefitRequests.hsaBenefitRequests; track request) {
                <div class="benefit-request-benefit">
                  {{request.name}}
                </div>
              }
            </div>
            <button class="mwp-button px-4 me-3" (click)="intializeEnrollment(benefitRequests.hsaYearRoundEnrollOptionId)">
              <mwp-text-translate text="Begin Request" jsonKey="benefitRequestsBeginRequest" />
            </button>
          </div>
        </div>
      }
      <!-- Voluntary Term Benefits -->
      @if (displayVoluntaryTerm) {
        <div class="content-container col-12 mb-4">
          <div class="d-flex justify-content-between align-items-center p-1">
            <div>
              <div class="benefit-request-category">
                <mwp-text-translate text="Voluntary Term Benefits" jsonKey="benefitRequestsVoluntaryTermBenefits" />
              </div>
              @for (request of benefitRequests.voluntaryTermBenefitRequests; track request) {
                <div class="benefit-request-benefit">
                  {{request.name}}
                </div>
              }
            </div>
            <button class="mwp-button px-4 me-3" (click)="intializeEnrollment(benefitRequests.voluntaryTermYearRoundEnrollOptionId)">
              <mwp-text-translate text="Begin Request" jsonKey="benefitRequestsBeginRequest" />
            </button>
          </div>
        </div>
      }
      <!-- 401K / Retirement -->
      @if (displayRetirement) {
        <div class="content-container col-12 mb-4">
          <div class="d-flex justify-content-between align-items-center p-1">
            <div>
              <div class="benefit-request-category">
                <mwp-text-translate text="401K / Retirement" jsonKey="benefitRequests401K/Retirement" />
              </div>
              @for (request of benefitRequests.retirementBenefitRequests; track request) {
                <div class="benefit-request-benefit">
                  {{request.name}}
                </div>
              }
            </div>
            <button class="mwp-button px-4 me-3" (click)="intializeEnrollment(benefitRequests.retirementYearRoundEnrollOptionId)">
              <mwp-text-translate text="Begin Request" jsonKey="benefitRequestsBeginRequest" />
            </button>
          </div>
        </div>
      }
    </div>
  }
</div>